import { RequestPartnerNewsImageUploadRequestSchema, RequestPartnerNewsImageUploadResponseSchema } from './request-partner-news-image-upload.schema';
export const requestPartnerNewsImageUploadContract = {
    method: 'POST',
    path: '/api/v2/admin/partner-news/:id/images/:slot/upload-url',
    description: 'Get a presigned POST for the logo or the image of a news entry',
    requestSchema: RequestPartnerNewsImageUploadRequestSchema,
    responseSchema: RequestPartnerNewsImageUploadResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only',
            404: 'Partner news not found'
        }
    }
};

//# sourceMappingURL=request-partner-news-image-upload.contract.js.map